import { render } from "./MonthResources.vue?vue&type=template&id=51aaeff8"
import script from "./MonthResources.vue?vue&type=script&lang=js"
export * from "./MonthResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__